export default [
  {
    value: 'NONE',
    title: 'Нет'
  },
  {
    value: 'IMAGE',
    title: 'Изображение'
  },
  {
    value: 'VIDEO',
    title: 'Видео'
  },
  {
    value: 'URL',
    title: 'URL'
  }
]
